import { Fragment, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Warning from "../../../assets/images/icons/warning.svg";
import Input from "../../inputs/inputs";
import Button from "../../buttons/buttons";
import { cleanInput } from "../../../helpers/cleanInput";
import { filterStoreOrders } from "../../../redux/storeOrders/storeOrderAction";
import { Beat } from "../../../plugins/spinners.plugin";

export default function FilterStoreOrdersDropDown({
  payLoad,
  page,
  isFilterOpen,
  setFilterState,
}) {
  const dispatch = useDispatch();
  const { isLoading, filtering } = useSelector((state) => state.business);

  const [errorMsg, setErrorMsg] = useState(false);
  const [couponInput, setCouponInput] = useState("");
  const [promoInput, setPromoInput] = useState("");
  const [data, setData] = useState({
    recipient_name: "",
    recipient_phone: "",
    recipient_city: "",
    order_amount: "",
    order_id: "",
    order_paid: "",
    status: payLoad?.status,
    order_coupons:[],
    order_promotion_codes:[],
  });
  const {
    recipient_name,
    recipient_phone,
    recipient_city,
    order_amount,
    order_paid,
    order_id,
    order_coupons,
    order_promotion_codes,
  } = data;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleAddCoupon = () => {
    if (couponInput.trim()) {
      setData((prevData) => ({
        ...prevData,
        order_coupons: [...(prevData.order_coupons || []), couponInput.trim()],
      }));
      setCouponInput("");
    }
  };

  const handleRemoveCoupon = (e, index) => {
    e.preventDefault();
    e.stopPropagation();
    setData((prevData) => ({
      ...prevData,
      order_coupons: (prevData.order_coupons || []).filter((_, i) => i !== index),
    }));
  };

  const handleCouponInputKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddCoupon();
    }
  };

  const handleAddPromo = () => {
    if (promoInput.trim()) {
      setData((prevData) => ({
        ...prevData,
        order_promotion_codes: [...(prevData.order_promotion_codes || []), promoInput.trim()],
      }));
      setPromoInput("");
    }
  };

  const handleRemovePromo = (e, index) => {
    e.preventDefault();
    e.stopPropagation();
    setData((prevData) => ({
      ...prevData,
      order_promotion_codes: (prevData.order_promotion_codes || []).filter((_, i) => i !== index),
    }));
  };

  const handlePromoInputKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddPromo();
    }
  };
  const handleReset = async () => {
    setData({
      recipient_name: "",
      recipient_phone: "",
      recipient_city: "",
      order_amount: "",
      order_id: "",
      order_paid: "",
      order_coupons: [],
      order_promotion_codes: [],
    });
    await dispatch(filterStoreOrders(payLoad, page));
    setFilterState(!isFilterOpen);
  };

  const handleSubmit = async () => {
    cleanInput(data);
    if (
      recipient_name ||
      recipient_phone ||
      recipient_city ||
      order_amount ||
      order_paid ||
      order_id ||
      order_coupons?.length > 0 ||
      order_promotion_codes?.length > 0
    ) {
      setErrorMsg(false);
      try {
        const response = await dispatch(filterStoreOrders({ ...data }, 1));
        if (response) {
          setFilterState(!isFilterOpen);
        }
      } catch (error) {
        console.log(error);
        setFilterState(!isFilterOpen);
      }
    } else {
      setErrorMsg(true);
    }
  };
  return (
    <>
      <div className="py-5 mt-4 px-5">
        <form className="text-left">
          <div className="grid grid-cols-1">
            <Input.Label
              title={"Customer Name"}
              htmlFor={"recipient_name"}
              name={"recipient_name"}
              onChange={handleChange}
              value={recipient_name}
              placeholder={"Enter Customer Name"}
            />
            <Input.Number
              title={"Customer Phone Number"}
              htmlFor={"recipient_phone"}
              name={"recipient_phone"}
              onChange={handleChange}
              value={recipient_phone}
              placeholder={"Enter Phone Number"}
            />
            <Input.Label
              title={"Customer City"}
              htmlFor={"recipient_city"}
              name={"recipient_city"}
              onChange={handleChange}
              value={recipient_city}
              autoComplete="off"
              placeholder={"Enter Customer City"}
              className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
            />
            <Input.Number
              title={"Order Id"}
              htmlFor={"order_id"}
              name={"order_id"}
              onChange={handleChange}
              value={order_id}
              placeholder={"Enter Order Id"}
            />
            <Input.Number
              title={"Order Amount"}
              htmlFor={"order_amount"}
              name={"order_amount"}
              onChange={handleChange}
              value={order_amount}
              placeholder={"Enter amount"}
            />
            <Input.Select
              title={"Order Paid"}
              htmlFor={"order_paid"}
              name={"order_paid"}
              value={order_paid}
              onChange={handleChange}
            >
              <option>Select payment status</option>
              <option value={"1"}>Paid</option>
              <option value={"0"}>Unpaid</option>
            </Input.Select>

            {/* Add Coupons */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-[#151515] dark:text-white">
                Order Coupons
              </label>
              <div className="mt-2 flex gap-2">
                <input
                  type="text"
                  value={couponInput}
                  onChange={(e) => setCouponInput(e.target.value)}
                  onKeyDown={handleCouponInputKeyDown}
                  placeholder="Enter coupon code"
                  className="flex-1 block pl-3 pr-10 text-base bg-[#FFFFFF] dark:bg-[transparent] focus:ring-2 focus:ring-red-600 focus:border-red-600 focus:outline-none sm:text-sm h-[40px] px-4 py-2 border border-gray-300 rounded-sm"
                />
                <button
                  type="button"
                  onClick={handleAddCoupon}
                  className="px-4 py-2 bg-red-600 text-white text-sm rounded-sm hover:bg-red-700 focus:outline-none h-[40px]"
                >
                  Add
                </button>
              </div>
              {order_coupons?.length > 0 && (
                <div className="mt-3 flex flex-wrap gap-2">
                  {order_coupons.map((coupon, index) => (
                    <div
                      key={index}
                      className="flex items-center gap-2 bg-gray-100 dark:bg-gray-800 px-3 py-1 rounded-full"
                    >
                      <span className="text-sm text-[#151515] dark:text-white">
                        {coupon}
                      </span>
                      <button
                        type="button"
                        onClick={(e) => handleRemoveCoupon(e, index)}
                        className="text-red-600 hover:text-red-800 focus:outline-none"
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Add Promotion Codes */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-[#151515] dark:text-white">
                Order Promotion Codes
              </label>
              <div className="mt-2 flex gap-2">
                <input
                  type="text"
                  value={promoInput}
                  onChange={(e) => setPromoInput(e.target.value)}
                  onKeyDown={handlePromoInputKeyDown}
                  placeholder="Enter promotion code"
                  className="flex-1 block pl-3 pr-10 text-base bg-[#FFFFFF] dark:bg-[transparent] focus:ring-2 focus:ring-red-600 focus:border-red-600 focus:outline-none sm:text-sm h-[40px] px-4 py-2 border border-gray-300 rounded-sm"
                />
                <button
                  type="button"
                  onClick={handleAddPromo}
                  className="px-4 py-2 bg-red-600 text-white text-sm rounded-sm hover:bg-red-700 focus:outline-none h-[40px]"
                >
                  Add
                </button>
              </div>
              {order_promotion_codes?.length > 0 && (
                <div className="mt-3 flex flex-wrap gap-2">
                  {order_promotion_codes.map((promo, index) => (
                    <div
                      key={index}
                      className="flex items-center gap-2 bg-gray-100 dark:bg-gray-800 px-3 py-1 rounded-full"
                    >
                      <span className="text-sm text-[#151515] dark:text-white">
                        {promo}
                      </span>
                      <button
                        type="button"
                        onClick={(e) => handleRemovePromo(e, index)}
                        className="text-red-600 hover:text-red-800 focus:outline-none"
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="py-8 grid grid-cols-2 gap-6 text-center">
              <Button.Secondary
                disabled={isLoading}
                title={isLoading ? <Beat color={"#ce2600"} /> : "Reset"}
                className="px-4"
                onClick={handleReset}
                type="button"
              />
              <Button.Primary
                disabled={filtering}
                title={filtering ? <Beat color={"#ffffff"} /> : "Filter"}
                className="px-4"
                onClick={handleSubmit}
                type="button"
              />
            </div>
          </div>
          {errorMsg && (
            <div className="flex gap-1 -mt-2">
              <img src={Warning} alt="warning" />
              <p>No value to filter by</p>
            </div>
          )}
        </form>
      </div>
    </>
  );
}
